export default __webpack_public_path__ + "static/media/help-guide-icon-white.4c2d67d3.svg";